import React from 'react';
import { DatadogAppWrapper } from '@/common/DatadogAppWrapper';

export const browser = () => {
  return <DatadogAppWrapper />;
};
